export default {
	'daily-journal': 'daily-journal',
	'sales-refunds': 'sales / refunds',
	'purchase-refunds': 'purchase / refunds',
	'in-out-cashbox': 'in / out cashbox',
	total: 'Total',
	'cash-total': 'Cash Total',
	'card-total': 'Card Total',
}